var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A179DC",
    d: "M23.891 7.993c0-.45-.096-.847-.29-1.188a2.27 2.27 0 0 0-.861-.838C19.573 4.14 16.403 2.32 13.238.493 12.384 0 11.557.018 10.71.518c-1.26.743-7.571 4.358-9.452 5.448C.484 6.414.107 7.1.107 7.992c-.002 3.672 0 7.344-.002 11.016 0 .44.093.83.279 1.165.19.345.48.634.873.861 1.88 1.09 8.192 4.704 9.452 5.448.848.5 1.675.518 2.529.025 3.166-1.828 6.335-3.648 9.503-5.474.392-.227.682-.516.873-.861.186-.336.278-.725.278-1.165l-.001-11.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280068",
    d: "M12.035 13.464.384 20.173c.19.345.48.634.873.86 1.88 1.09 8.192 4.705 9.452 5.449.848.5 1.675.518 2.529.025 3.166-1.828 6.335-3.648 9.503-5.474.392-.227.682-.516.873-.861l-11.579-6.708Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#390091",
    d: "M23.891 7.993c0-.45-.096-.847-.29-1.187l-11.566 6.659 11.58 6.707c.185-.335.277-.725.277-1.165l-.001-11.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.895 10.956v1.254h1.254v-1.254h.627v1.254h1.254v.627h-1.254v1.254h1.254v.627h-1.254v1.254h-.627v-1.254h-1.254v1.254h-.627v-1.254h-1.254v-.627h1.254v-1.254h-1.254v-.627h1.254v-1.254h.627Zm1.254 1.881h-1.254v1.254h1.254v-1.254Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.06 4.658a8.838 8.838 0 0 1 7.657 4.417l-.015-.025-3.849 2.215a4.4 4.4 0 0 0-3.742-2.168h-.05a4.403 4.403 0 1 0 3.836 6.562l-.018.032 3.842 2.226a8.839 8.839 0 0 1-7.562 4.424h-.098A8.838 8.838 0 0 1 3.219 13.5a8.842 8.842 0 0 1 8.842-8.842Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.998v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.2522c48fd048cbbaf524f4eee560a54d.svg";
export { ForwardRef as ReactComponent };